import { atom } from 'recoil';

export const dataFormCommerceFinish = atom({
  key: 'dataFormCommerceFinish',
  default: undefined,
});
